export default "__VITE_ASSET__Q$Igrwfm__"